import axios, { isAxiosError } from 'axios';
import { t } from 'i18next';

import type { APIResponse } from '@/@types/types';
import type { TokenInfo } from '@/@types/user';

const setting = {
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
};
const noAuthPage = ['/login', '/sign-up', '/pricing', '/refund-policy'];

//token이 필요없는 request에서 사용
export const noAuthInstance = axios.create(setting);

//token이 필요한 request에서 사용
export const instance = axios.create(setting);

//token이 필요한 경우 각각의 처리에서 진행하지 않고 공통으로 처리
//token의 유효성 체크 및 재발행까지 진행
//token이 유효하지 않은 경우 에러메시지 표시(alert) 후 reject
instance.interceptors.request.use(async (req) => {
  const tokenString = localStorage.getItem('TOKEN');
  if (!tokenString) {
    console.error('[interceptor] NO TOKEN');
    return Promise.reject('INTERCEPTOR_NO_TOKEN');
  }

  const { accessToken, refreshToken } = JSON.parse(tokenString);
  try {
    const validToken = await getValidToken(accessToken, refreshToken);
    req.headers.Authorization = `Bearer ${validToken.accessToken}`;
    return req;
  } catch (err) {
    if (!noAuthPage.includes(window.location.pathname)) {
      window.alert(t('Logout.message.loginExpired'));
      window.location.assign('/login');
    }
    return Promise.reject();
  }
});

async function getValidToken(accessToken: string, refreshToken: string) {
  try {
    const headers = { Authorization: `Bearer ${accessToken}` };
    await noAuthInstance.get<APIResponse>('/auth/check', { headers });
    return { accessToken, refreshToken };
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[isValidToken] API error code:', err.response.data.errorCode);
        if (err.status >= 400 && err.status < 500) {
          // Try refresh access token
          const refreshedToken = await getRefreshedToken(refreshToken);
          if (refreshedToken === null) {
            // Refresh failed
            console.error('[isValidToken] Login expired');
            return Promise.reject();
          }
          // Refresh success
          console.log('[isValidToken] Refresh token success');
          return refreshedToken;
        } else {
          return Promise.reject();
        }
      } else {
        console.error('[isValidToken] Axios error message:', err.message);
        return Promise.reject();
      }
    } else {
      console.error('[isValidToken] Unknown error', err);
      return Promise.reject();
    }
  }
}
async function getRefreshedToken(refreshToken: string) {
  const autoLogin = localStorage.getItem('AUTO_LOGIN') === 'true' ? true : false;
  if (!autoLogin) return null;

  try {
    const { data } = await noAuthInstance.post<APIResponse<TokenInfo>>('/auth/refresh', { refreshToken });
    localStorage.setItem('TOKEN', JSON.stringify(data.data));
    return data.data;
  } catch (err) {
    console.error('[handleRefresh] Refresh token failed');
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[handleRefresh] API error code:', err.response.data.errorCode);
      } else {
        console.error('[handleRefresh] Axios error message:', err.message);
      }
    } else {
      console.error('[handleRefresh] Unknown error', err);
    }
    return null;
  }
}

// noAuthInstance.interceptors.response.use(
//   res=> res,
//   error=>{
//     const err = {...error,message:'ERRRRRR'};
//     console.log(err,isAxiosError(err));
//     return err;
//   }
// )
